import { formatMoney } from 'theme';
import { getProductTitleParts } from 'swatches';
import { h } from 'preact';
import htm from 'htm';

const html = htm.bind(h);
const b2b = document.body.dataset.b2b;

function priceOutput(b2b) {
  // b2b customer
  if (b2b) {
    return html`
      <span class="ac-price">View Product for Special Pricing</span>`;

  // not b2b, item is on sale
  } else if (item.compare_at_price > item.price) {
    return html` 
      <span class="ac-compare-at-price line-through">
        <span class="sr-only">Regular price:</span>
        ${formatMoney(item.compare_at_price * 100)}
      </span>
      <span class="ac-sale-price text-on-sale">
        <span class="sr-only">Sale price:</span>
        ${formatMoney(item.price * 100)}
      </span>`;

  // not b2b, regular price
  } else {
    return html`
      <span class="ac-price">${formatMoney(item.price * 100)}</span>`;
  }
}

export function productCardTemplate(item) {
  const [title] = getProductTitleParts(item.title);

  return html`
    <a href="/products/${item.handle}" class="ac-product-card">
      <img src="${item.image}" alt="" loading="lazy" />
      <span class="ac-product-card__title">${title}</span>
      <span class="sr-only">, Price: </span>
      <span class="ac-product-card__price">${priceOutput(b2b)}</span>
    </a>
  `;
}